module.exports = __webpack_public_path__ + "images/groups-img-mobile.35c981dd7d60dd504b7fcd4bcf61fe4b.png";